import Backbone from 'backbone'
import template from './key-value.hbs'

/**
 * A simple view which contains a key and a value. For example, used to specify
 * request parameters for a REST import.
 */
const KeyValue = Backbone.View.extend(/** @lends {KeyValue} */{

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {String} options.key the key
	 *
	 * @param {Object} options.value
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		// Use replaceWith() instead of append() to prevent extra html #55248
		this.$el.replaceWith(template(this.options))
		return this
	},

	autoRemove: true

})

export default KeyValue

KeyValue.__filename__ = 'imports/rest/key-value.js'
